
import React from 'react';
import AccessoriesSelector from 'bom/components/accessoriesSelector/accessoriesSelector';
import { navigationService } from '__common/services/navigationService';
import AttachmentsSelector from 'bom/components/attachmentsSelector/attachmentsSelector';
import MetalxAttachmentSelector from 'bom/components/attachmentsSelector/components/metalXAttachmentSelector';
import autobind from 'autobind-decorator';
import BackButton from 'app/components/FooterComponent/BackButton';
import ContinueButton from 'app/components/FooterComponent/ContinueButton';
import BomTable from 'bom/components/bomTable/bomTable';
import Drawer from '__common/components/Drawer/Drawer';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import ProjectInfoHeaderMiddleBar from 'projectDesign/components/ProjectInfoHeaderMiddleBar';
import Loader from '__common/components/LoaderComponent';
import RailsSelector from 'bom/components/railsSelector/railsSelectorComponent';
import BallastRailSelector from 'bom/components/ballastRailSelector/ballastRailSelector';
import SaveBom from 'bom/components/saveBomButton';
import { calculatePrices } from 'bom/bomHelpers';
import { connect } from 'react-redux';
import { footerHeight, headerHeight } from '__common/constants/layout_css_dims';
import { getBomBasicPages } from './utils/bomDrawerPages';
import { bomPageView } from './utils/bomPageContent';
import { getDefaultRailsList } from 'bom/components/railsSelector/utils/getDefaultRailsList';
import { getProductTitle } from '__common/constants/products_titles';
import { loadBomSelections } from 'bom/components/utils/loadBomSelections';
import { saveBom } from 'bom/utils/saveBom';
import { getBomFailureMessage } from 'bom/getBomFailureMessage';
import {
  isRMFamily,
  isSFMFamily,
  isSMFamily,
  products,
  isULA,
  isMetalX,
  isEcoFoot2Plus,
  isNxtHorizon,
  isSMTiltPR,
  isAscender,
  getProductName,
  isNxtTilt,
  isSMTiltPRWithAscender,
  isRmGridflex10D,
  isRmGridflex5Rwdi,
} from '__common/constants/products';
import {
  CLEAR_PK,
  FETCH_BOM_PART_LIST_REQUEST,
  SET_BOM_PRODUCT,
  SET_NEW_PART_QUANTITY,
  SET_PRODUCT_TITLE,
  LOAD_RAILS_LIST,
  SET_PROJECT_NAME,
  BOM_RESET,
  CLEAR_RAILS_LIST,
  SET_PRODUCT_ID,
  HIDE_MODAL_FOR_AURORA_REPORTS,
  SEND_BOM_DATA_TO_AURORA,
  SET_RAILS_PRODUCT_ID,
  HIDE_MODAL_FOR_OS_REPORTS,
  SEND_BOM_DATA_TO_OS,
  SET_NEW_PART_PRICE,
} from 'actions';

import BomWarnings from 'bom/components/warnings/bomWarnings';
import { check_sm_url_conversion_criteria } from './ProjectDesign';
import { dispatch, state } from '__common/store';
import ModalForAuroraBomReport from 'bom/components/ModalForAuroraBomReport';
import { FLASHLOC_PARTS, TILT_LEG_LFOOT_PARTS } from '__common/constants/parts';
import { showWarningAlert } from '__common/modules/alerts';
import ModalForOsBomReport from 'bom/components/ModalForOsBomReport';
import TileReplacementSelector from 'bom/components/tileReplacementSelector/tileReplacementSelector';

type Props = {
  bom: bomState,
  dispatch: (action: any) => void,
  match: any,
  railsList: railsSelectorState,
  isRailsFetching: boolean,
  projectConfiguration: projectConfigurationState,
  loaderMsg: string,
};

type State = {
  bomIsRedirecting: boolean,
};

const getInitialRailList = (
  productId: string,
  railFinish: string,
  selectedRails?: railsList
) => {
  const defaultRailsList = getDefaultRailsList(products[productId], railFinish);

  if (!selectedRails || !selectedRails.length) {
    return defaultRailsList;
  }

  return defaultRailsList.map((rail) => ({
    ...rail,
    selected: selectedRails.some((selectedRail: any) => {
      if (typeof selectedRail === 'number') return selectedRail === rail.length;
      return !!(selectedRail && selectedRail.selected && selectedRail.length === rail.length);
    }),
  }));
};
class Bom extends React.Component<Props, State> {
  state = {
    bomIsRedirecting: false,
  };


  UNSAFE_componentWillMount() {
    const { dispatch, match: { params: { projectId, productId } } } = this.props;
    
    // Clear the design-page redirect flag before validating the slug. If this
    // returns early, pk stays set and the design page immediately sends the
    // user back here.
    dispatch(CLEAR_PK());

    // Make sure we have valid parameters before proceeding
    if (!projectId || !productId || !products[productId]) {
      console.error('Invalid projectId or productId', { projectId, productId });
      return;
    }
    dispatch(CLEAR_RAILS_LIST());
    dispatch(FETCH_BOM_PART_LIST_REQUEST(projectId, productId));
    dispatch(SET_BOM_PRODUCT(products[productId], projectId));
  }

  componentDidMount() {
    const { dispatch, match: { params: { productId } } } = this.props;

    window.addEventListener('resize', this.handleResize);

    if (products[productId] !== 9){
    // if (products[productId] !== 9 || products[productId] !== 34) {
      dispatch(SET_PRODUCT_TITLE(getProductTitle(products[productId], true)));
    }
  }

  componentDidUpdate(prevProps: Props) {
const { dispatch, bom, projectConfiguration, match: { params: { productId, projectId } }, bom: { extraParameters: { is_sm_tilt, selections, project_rail_finish }, reload_selections }, railsList: { railsLoaded } } = this.props;
    // if (projectEnvConfig?.is_aurora_project && prevProps.bom.extraParameters?.arrays_id !== this.props.bom.extraParameters.arrays_id) {
    //   if (this.props.bom.extraParameters.arrays_id && this.props.bom.extraParameters.arrays_id.length > 0) {
    //     this.props.bom.extraParameters.arrays_id.forEach((item, index)=>{
    //       dispatch(BALLAST_GENERATING_START(item , 0, projectId, 'customary' ))
    //     })
    //   }
    // }
    if (prevProps.bom.project_name === '' && this.props.bom.project_name) {
      dispatch(SET_PROJECT_NAME(this.props.bom.project_name));
    }
    if(!prevProps.projectConfiguration.railsProductId && !this.props.projectConfiguration.railsProductId) {
      dispatch(SET_RAILS_PRODUCT_ID(products[productId]));
    }
    if (Object.keys(prevProps.bom.extraParameters).length === 0 && Object.keys(this.props.bom.extraParameters).length > 0) {
      if (!(check_sm_url_conversion_criteria(productId,this.props.bom.extraParameters.productId) )
      && getProductName(this.props.bom.extraParameters.productId) != productId) {
        dispatch(SET_PRODUCT_ID(this.props.bom.extraParameters.productId));
        navigationService.push('/projectNotFound');
      }



      const id = is_sm_tilt ? 99 : products[productId];
      if (reload_selections) {

        if (isSMFamily(productId) && railsLoaded) {
          loadBomSelections(selections, productId, projectId);
        } else if (isAscender(productId) && railsLoaded) {
          loadBomSelections(selections, productId, projectId);
        } else if (isNxtHorizon(productId) && railsLoaded) {
          loadBomSelections(selections, productId, projectId);
        } else if (isNxtTilt(productId) && railsLoaded) {
          loadBomSelections(selections, productId, projectId);
        } else if (!isSMFamily(productId)) {
          loadBomSelections(selections, productId, projectId);
        } else if (isSMTiltPR(productId) && railsLoaded) {
          loadBomSelections(selections, productId, projectId);
        }
      }
      dispatch(SET_PRODUCT_TITLE(getProductTitle(id)));
    }
    if(
      this._shouldLoadRails() && bom.isReady &&  !prevProps.railsList.railsList.length && !this.props.railsList.railsList.length && Object.keys(this.props.bom.extraParameters).length)
     {
      dispatch(LOAD_RAILS_LIST(getInitialRailList( productId, project_rail_finish,
      selections?.selected_rails)))
     }

    if (this._shouldRedirectToThirdPageAfterSelections() && !this.state.bomIsRedirecting) {
      this.setState({ bomIsRedirecting: true });
      saveBom(false);
    }

    if (
      bom.partsList?.length > 0 &&
      projectConfiguration?.projectEnvConfig?.uanchor_part_number?.length
    ) {
      const uanchorNumbers = projectConfiguration.projectEnvConfig.uanchor_part_number;
  
      bom.partsList.forEach((part) => {
        if (uanchorNumbers.includes(part.number) && part.price !== 0) {
          dispatch(SET_NEW_PART_PRICE(part.number, 0.00));
        }
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    window.removeEventListener('resize', this.handleResize);
    dispatch(BOM_RESET());
  }

  _shouldLoadRails() {
    const { match: { params: { productId } } } = this.props;
    return [
      products.solarmount_hd,
      products.sunframe,
      products.solarmount_2,
      products.solarmount_lt,
      products.solarmount_ascender_flush,
      products.solarmount_2_tilt,
      products.nxt_tilt,
      products.gft,
      //products.ula,
      products.nxt_umount,
      products.nxt_horizon_hd,
      products.nxt_horizon_lt,
      products.ascender,
      products.sm_tilt_pr,
      products.sm_tilt_pr_lt,
      products.sm_tilt_pr_ascender_rail
    ].includes(products[productId]);
  }

  _shouldRedirectToThirdPageAfterSelections() {
    const { bom: { partsList, reload_selections, extraParameters: { selections }, stdClampsFetched, goToEngineeringFromBom }, railsList: { railsLoaded } } = this.props;

    if (
      reload_selections &&
      goToEngineeringFromBom &&
      ((this._shouldLoadRails() && railsLoaded) || (this._shouldLoadRails() && (!selections.selected_rails || !selections.selected_rails.length)) || (!this._shouldLoadRails() && !railsLoaded)) &&
      ((selections.accessories.includes('STDCLAMPS') && stdClampsFetched) || !selections.accessories.includes('STDCLAMPS'))
    ) {
      return true;
    }

    if (goToEngineeringFromBom && !reload_selections && partsList.length) {
      return true;
    }

    if (!railsLoaded) {
      return false;
    }
  }

  auroraReportCancel() {
    dispatch(HIDE_MODAL_FOR_AURORA_REPORTS());
  }
  osReportCancel() {
    dispatch(HIDE_MODAL_FOR_OS_REPORTS());
  }
  retrySendBomData() {
    const {projectConfiguration:{projectId}} = state();
    dispatch(SEND_BOM_DATA_TO_AURORA(projectId));
  }
  retrySendOsBomData() {
    const {projectConfiguration:{projectId}} = state();
    dispatch(SEND_BOM_DATA_TO_OS(projectId));
  }

  @autobind
  handleResize() {
    this.forceUpdate();
  }

  @autobind
  onChangeQuantity(partNumber, newQty) {
    const { dispatch, bom: { partsList } } = this.props;
    if (newQty > 1000000) {
      dispatch(SET_NEW_PART_QUANTITY(partNumber, 1000000));
    } else {
      dispatch(SET_NEW_PART_QUANTITY(partNumber, newQty));
    }
    if(TILT_LEG_LFOOT_PARTS.includes(partNumber) && partsList.some(({number}) => FLASHLOC_PARTS.includes(number))) {
      showWarningAlert("Please update flashloc anchor quantity, if required.");
    }
  }

  renderLoader() {
    const { bom: { isLoading }, isRailsFetching } = this.props;
    
    let message = 'Loading BOM...';

    if (isLoading) {
      message = 'Generating Bill of Materials...';
    } else if (isRailsFetching) {
      message = 'Loading rail configurations...';
    }
    
    return (
      <div className="bom-loader-container">
        <Loader />
        <div className="bom-loader-message">{message}</div>
      </div>
    );
  }
  renderHeaderPrices() {
    const { match: { params: { projectId } } } = this.props;
    return <ProjectInfoHeaderMiddleBar projectId={projectId} />;
  }

  renderBom() {
    const { match: { params: { productId, projectId } }, railsList: { railsList }, dispatch } = this.props;
    const { partsList, attachmentsList,tileReplacementList, warningsInfo } = this.props.bom;
    const numericProductId = products[productId];
    const viewportHeight = window.innerHeight;
    const drawerHeight = viewportHeight - headerHeight - footerHeight;
    const PAGES = getBomBasicPages(productId, warningsInfo?.warnings || []);
    const showMetalxAttachments = isMetalX(products[productId]) && attachmentsList && Object.keys(attachmentsList).length > 0;
    const ballastRailSelection = this.props.bom.extraParameters &&
      this.props.bom.extraParameters.ballast_rail_selection;
    const showBallastRailSelector = (
      isRmGridflex10D(products[productId]) ||
      isRmGridflex5Rwdi(products[productId])
    ) && ballastRailSelection && ballastRailSelection.editable;

    if (PAGES[0]) {
      PAGES[0].content = (
        <>
          {railsList && (Object.keys(railsList).length > 0 || isULA(products[productId]) || isNxtHorizon(products[productId]) || isNxtTilt(products[productId]) || isSMTiltPRWithAscender(products[productId]) || isSMTiltPR(products[productId]) || isAscender(products[productId])) && (<RailsSelector productId={productId} projectId={projectId} />)}
          {showBallastRailSelector && (<BallastRailSelector productId={products[productId]} />)}
          {!isMetalX(products[productId]) && attachmentsList && Object.keys(attachmentsList).length > 0 && (<AttachmentsSelector productId={productId} />)}
          {tileReplacementList && Object.keys(tileReplacementList).length > 0 && (<TileReplacementSelector productId={productId} />)}
          {showMetalxAttachments && (<MetalxAttachmentSelector productId={productId} />)}

        </>
      );
    }

    if (PAGES[1]) {
      PAGES[1].content = <AccessoriesSelector productId={productId} projectId={projectId} legacyCheckboxIcons={true} />;
    }

    if (PAGES[2]) {
      PAGES[2].content = (
        <>
          {warningsInfo?.warnings?.length && (<BomWarnings productId={productId} />)}
        </>
      );
      PAGES[0] = { ...PAGES[0], active: false };
      PAGES[2] = { ...PAGES[2], active: true };
    }

    const shouldRemoveFirstPage = (isRMFamily(products[productId]) && !showBallastRailSelector) || (isEcoFoot2Plus(products[productId])) || isULA(products[productId]) ||
      (isSFMFamily(products[productId]) && !(tileReplacementList && Object.keys(tileReplacementList).length)) ||
      (isMetalX(products[productId]) && !showMetalxAttachments);

    if (shouldRemoveFirstPage) {
      PAGES.shift();
      PAGES[0].active = true;
    }

    return (
      <div 
        className="bom-content" 
        style={{ 
          height: `${drawerHeight}px`, 
          display: 'flex',
          overflow: 'hidden'
        }}
      >
        <Drawer
          keepOpen={true}
          legacy={true}
          productId={numericProductId}
          pages={PAGES} 
          drawerHeight={drawerHeight} 
          listClass="bom-control-panel"
        />
        <div 
          className="bom-main-content" 
          style={{ 
            flex: 1, 
            overflow: 'auto', 
            height: '100%' 
          }}
        >
          <BomTable 
            projectId={projectId} 
            dispatch={dispatch} 
            partsList={partsList} 
            onChangeQuantity={this.onChangeQuantity} 
            productId={productId} 
          />
        </div>
        <ModalForAuroraBomReport bom={this.props.bom} showModal={this.props.bom?.auroraReport?.show}/>
        <ModalForOsBomReport bom={this.props.bom} showModal={this.props.bom?.osReport?.show}/>
      </div>
    );
  }

  @autobind
  renderFooter() {
    const { dispatch, match: { params: { projectId, productId } } } = this.props;
    const {projectConfiguration:{projectEnvConfig:{is_aurora_project}}} = state();
    const url = `/project/design/${productId}/${projectId}`;
    return (
      <span style={{ display: 'flex' }}>
        <BackButton url={url} dispatch={dispatch} action={CLEAR_PK} />
        {
          //!(is_aurora_project || is_os_project) && (
            // <SaveBom projectId={projectId} productId={productId} />
          //)
        }
        {
          !is_aurora_project && (
            <ContinueButton
              onClick={() => {
                // SAVE_BOM success sets bomPk; render redirects only after the
                // save completes so leaving this page cannot race persistence.
                saveBom(false);
              }}
            />
          )
        }
      </span>
    );
  }

  render() {
    const {
      bom: {
        error,
        isLoading,
        isReady,
        bomPk,
        goToEngineeringFromBom,
      },
      match: {
        params: {
          productId,
          projectId,
        },
      },
      railsList: {
        railsList,
      },
      isRailsFetching,
      loaderMsg,
    } = this.props;

    // bomPk is set immediately for an unchanged BOM, or by the save epic after
    // a changed BOM is persisted successfully.
    if (bomPk) {
      navigationService.push(`/project/engineering/${productId}/${projectId}`);
      return null;
    }

    let content: JSX.Element;

    if (!productId || !products[productId]) {
      content = (<div className="error-message">Invalid product ID. Please go back and try again.</div>);
    } else if (error) {
      if (error.status === 401) {
        content = (<div className="error-message">Not authorized. Please log in again.</div>);
      } else if (error.status === 404) {
        navigationService.push('/projectNotFound');
        return null;
      } else {
        // Match production: show the gears loader with the backend exception
        // (e.g. "Structure is not feasible, please change module dimension or module tilt")
        // instead of a generic "Error loading BOM data" banner.
        content = (<Loader overrideMsg={getBomFailureMessage(error, loaderMsg)} />);
      }
    } else if (bomPageView({
      isLoading,
      isReady,
      isRailsFetching,
      shouldLoadRails: this._shouldLoadRails(),
      railsCount: railsList ? railsList.length : 0,
    }) === 'bom') {
      content = this.renderBom();
    } else {
      content = this.renderLoader();
    }
    if (goToEngineeringFromBom) {
      content = this.renderLoader();
    }

    return (
      <div className="bom-page">
        <Header navigation={true} Infobar={this.renderHeaderPrices()} productId={productId} projectId={projectId} />
        {content}
        <Footer ContainerFooter={this.renderFooter} />
      </div>
    );
  }
}

function mapPropTypes(state: appState) {
  return {
    bom: state.bom,
    railsList: state.railsSelector,
    isRailsFetching: state.railsSelector.railsFetching,
    projectConfiguration: state.projectConfiguration,
    loaderMsg: state.app?.loaderMsg || '',
  };
}

export default connect(mapPropTypes)(Bom);
